/* eslint-disable import/prefer-default-export */
export function checkedTutorials(state) {
  return state.checkedTutorials;
}



// WEBPACK FOOTER //
// ./src/app/tutorials/store/getters.js